export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_ALIGN = 'desc' as const;
export const DEFAULT_ORDER_BY = 'createdAt';
export const DEFAULT_QUERY = '';
export const SEARCH_DEBOUNCE_TIME = 300;
